import { FunctionComponent } from 'react';
import { BingoCardBox } from './BingoCardBox';
import { GameCardContainerType } from '../../Games/GameCard/GameCard.types';
import { BingoCardTall } from './BingoCardTall';
import { BingoCardWide } from './BingoCardWide';
import { useGameDetailsUrl } from '../../../hooks/games';
import { GameType } from '../../Games/games.model';
import { useAuth } from 'react-oidc-context';
import { useBrandedNavigate } from '../../../hooks/useBrandedNavigate';
import { useSignIn } from '../../../hooks/auth';

export interface BingoData {
  id: string;
  roomID?: string;
  number_of_balls?: number;
  min_bet?: string;
  max_bet?: string;
  cardCost?: Nullable<string>;
  jackpot?: Nullable<string>;
  prize?: Nullable<string>;
  hasRealTimeData: boolean;
  img?: {
    __typename?: 'directus_files';
    id: string;
    filename_disk?: string | null;
    title?: string | null;
    width?: number | null;
    height?: number | null;
  } | null;
  imgBox?: {
    __typename?: 'directus_files';
    id: string;
    filename_disk?: string | null;
    title?: string | null;
    width?: number | null;
    height?: number | null;
  } | null;
  imgWide?: {
    __typename?: 'directus_files';
    id: string;
    filename_disk?: string | null;
    title?: string | null;
    width?: number | null;
    height?: number | null;
  } | null;
  bannerImage?: {
    __typename?: 'directus_files';
    id: string;
    filename_disk?: string | null;
    title?: string | null;
    width?: number | null;
    height?: number | null;
  } | null;
  title?: string;
  ctaText: string;

  slug: string;
  players: Nullable<string>;
  gameStartEpoch?: number | null;
}

export const BingoCard: FunctionComponent<{ bingo: BingoData; type: GameCardContainerType }> = ({
  bingo,
  type,
}): JSX.Element => {
  const { buildGameDetailsUrl } = useGameDetailsUrl(GameType.Bingo, GameType.Bingo);
  const auth = useAuth();
  const signIn = useSignIn();
  const { navigate } = useBrandedNavigate();
  const isUserAuthenticated = auth?.isAuthenticated;

  const handleCardClick = (): void => {
    isUserAuthenticated
      ? navigate(buildGameDetailsUrl(bingo.slug, 'real'))
      : signIn({ redirectUri: new URL(buildGameDetailsUrl(bingo.slug, 'real'), window.location.origin).toString() });
  };

  return (
    <div role="button" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      {type === GameCardContainerType.Box && <BingoCardBox onPlay={handleCardClick} bingo={bingo} />}
      {type === GameCardContainerType.Tall && <BingoCardTall onPlay={handleCardClick} bingo={bingo} />}
      {type === GameCardContainerType.Wide && <BingoCardWide onPlay={handleCardClick} bingo={bingo} />}
    </div>
  );
};
